import React from "react";
import { C, STEPS } from "../utils/tokens";

const Stepper = ({ current, tpl }) => {
  const activeColor = tpl?.color || C.gold;

  return (
    <>
      <style>{`
        /* Container flessibile principale */
        .stepper-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding: 8px 4px 16px 4px;
        }

        /* Elemento singolo dello step */
        .stepper-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          position: relative;
          z-index: 2;
        }

        /* Label di testo sotto l'icona */
        .stepper-label {
          font-size: 9px;
          font-family: 'DM Mono', monospace;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          white-space: nowrap;
          transition: color 0.3s ease;
        }

        /* Linea di connessione desktop */
        .stepper-line {
          flex: 1;
          height: 2px;
          margin-top: -16px; /* Alimenta perfettamente il centro dei box da 36px */
          transition: background 0.3s ease;
        }

        /* ADATTAMENTO SMARTPHONE (Niente scroll orizzontale) */
        @media (max-width: 768px) {
          .stepper-container {
            padding: 4px 0 10px 0 !important;
          }
          
          /* Nascondiamo le linee di connessione per recuperare spazio */
          .stepper-line {
            display: none !important;
          }

          /* Gestione dei testi su mobile per evitare collisioni */
          .stepper-item .stepper-label {
            display: none; /* Nasconde i testi degli step non attivi */
          }

          /* Mostra il testo SOLO per lo step in cui l'utente si trova */
          .stepper-item.is-current .stepper-label {
            display: block !important;
            position: absolute;
            top: 42px;
            font-size: 8.5px !important;
            text-align: center;
          }
          
          /* Cambia il margine inferiore del container quando c'è una label attiva su mobile */
          .stepper-container {
            margin-bottom: 12px !important;
          }
        }
      `}</style>

      <div className="stepper-container">
        {STEPS.map((s, i) => {
          const isCurrent = current === s.id;
          const isCompleted = current > s.id;

          // Gestione dinamica dei bordi e sfondi in linea con l'estetica Neon/Cyberpunk
          const borderStyle = isCurrent
            ? `2px solid ${activeColor}`
            : isCompleted
              ? `2px solid ${activeColor}55`
              : `2px solid ${C.border}`;

          const backgroundStyle = isCurrent
            ? `${activeColor}18`
            : isCompleted
              ? `${activeColor}09`
              : "rgba(255,255,255,0.02)";

          const colorStyle = isCurrent
            ? activeColor
            : isCompleted
              ? `${activeColor}88`
              : C.border;

          return (
            <React.Fragment key={s.id}>
              {/* Contenitore Step */}
              <div className={`stepper-item ${isCurrent ? "is-current" : ""}`}>
                <div
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 8,
                    border: borderStyle,
                    background: backgroundStyle,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: isCompleted ? 12 : 14,
                    color: colorStyle,
                    boxShadow: isCurrent ? `0 0 16px ${activeColor}33` : "none",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  }}
                >
                  {isCompleted ? "✓" : s.icon}
                </div>

                <span className="stepper-label" style={{ color: colorStyle }}>
                  {s.label}
                </span>
              </div>

              {/* Linea di collegamento — Renderizzata solo tra gli elementi */}
              {i < STEPS.length - 1 && (
                <div
                  className="stepper-line"
                  style={{
                    background: isCompleted ? `${activeColor}50` : C.border,
                    opacity: isCompleted ? 1 : 0.4,
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default Stepper;
